import { css } from '@emotion/css';
import userApi from 'apis/userApi';
import LoadingIcon from 'components/loading/LoadingIcon';
import { msgAlertInput } from 'constants/messageAlert';
import { AgentSignPayload } from 'models/agentModel';
import { useEffect, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import accountStyles from './account-option.style';

function AgentSign() {
    const pointsscRef = useRef<number>(0);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        setFocus,
        setError,
        setValue,
    } = useForm<AgentSignPayload>();

    useEffect(() => {
        const agentSignInit = async () => {
            try {
                const { data } = await userApi.agentRegisterInit({});
                if (!data.msg) {
                    pointsscRef.current = data.pointssc;
                }
            } catch (error) {
                console.log(error);
            }
        };
        agentSignInit();
    }, []);

    const onSubmitAgentSign: SubmitHandler<AgentSignPayload> = async (values) => {
        const { pwd, pwdre } = values;
        if (pwd !== pwdre) {
            setError('pwdre', {
                message: msgAlertInput.prepassword.invalid,
            });
            setFocus('pwdre');
            return;
        }

        setLoading(true);
        const payload = {
            ...values,
            pointssc: pointsscRef.current,
        };
        try {
            const { data } = await userApi.agentRegisterSave(payload);
            if (!data.msg) {
                toast.success(`Đăng ký tài khoản ${values.loginname} thành công`);

                //reset form
                for (const key in values) {
                    setValue(key as any, '');
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className={`${accountStyles.wrap} ${styles.container}`}>
                <h6 className={styles.title}>Thông tin cơ bản</h6>
                <form className={styles.viewAllInput} onSubmit={handleSubmit(onSubmitAgentSign)}>
                    <div className={styles.groupInput}>
                        <label className="titleInput" htmlFor="">
                            Tên Đăng Nhập:
                        </label>
                        <input
                            type={'text'}
                            {...register('loginname', {
                                required: true,
                                maxLength: { value: 30, message: msgAlertInput.generic.maxLength(30) },
                                pattern: { value: msgAlertInput.username.pattern, message: msgAlertInput.generic.noWhiteSpace },
                            })}
                            className={styles.wrapInput}
                        />
                        <label className="titleInputSub">{'(5 ký tự trở lên)'}</label>
                    </div>

                    <div className={styles.groupInput}>
                        <label className="titleInput" htmlFor="">
                            Mật Khẩu
                        </label>
                        <input {...register('pwd', { required: true })} className={styles.wrapInput} type={'password'} />
                        <label className="titleInputSub">{'(6 ký tự trở lên)'}</label>
                    </div>

                    <div className={styles.groupInput}>
                        <label className="titleInput">Xác Nhận Mật Khẩu</label>
                        <input {...register('pwdre', { required: true })} className={styles.wrapInput} type={'password'} />
                        <label className="titleInputSub">{'(Giống với mật khẩu đã nhập)'}</label>
                    </div>

                    <div className={styles.groupInput}>
                        <label className="titleInput" htmlFor="">
                            Biệt Danh
                        </label>
                        <input {...register('nickname', { required: true })} className={styles.wrapInput} type="text" />
                    </div>

                    <button type="submit" className={styles.btnSubmit}>
                        Tạo Tài Khoản
                    </button>
                </form>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

export default AgentSign;

const styles = {
    viewAllInput: css`
        display: flex;
        flex-direction: column;
        gap: 35px;
        padding-top: 10px;
        padding-bottom: 10px;
    `,
    container: css`
        color: black;
    `,
    title: css`
        font-size: 22px;
        margin-bottom: 10px;
        font-weight: 400;
    `,
    groupInput: css`
        display: flex;
        align-items: center;
        gap: 20px;
        .titleInput {
            width: 350px;
            text-align: right;
            font-size: 16px;
            font-weight: 300;
        }

        .titleInputSub {
            width: 200px;
            font-size: 14px;
            font-weight: 300;
        }
    `,

    wrapInput: css`
        display: flex;
        width: 250px;
        border: none;
        height: 30px;
        border-bottom: 1px solid #000;
    `,

    btnSubmit: css`
        background: #ffad33 !important;
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        color: #fff !important;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        align-self: center;
        margin-top: 10px;
    `,
};
